export default __webpack_public_path__ + "static/media/049-speed camera.11651251.png";